var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hd-format antialiased",class:_vm.background,attrs:{"id":"app"}},[(_vm.showProgramLine)?_c('ProgramLine'):_c('Logo',{staticClass:"absolute top-0 right-0 z-40 w-[75px] m-[92px]"}),_c('Commercials',{attrs:{"active-on-start":_vm.commercialsInitiallyActive()}}),_c('DynamicGraphics')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }